<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-10-17 14:58:30
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-11-17 17:44:25
 * @FilePath: /chaoyongtuan/src/views/shopManage/commercialHigh/components/search/searchBox.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="search-input">
		<el-select class="select-content" v-model="search.selectType" placeholder="请选择" @change="onSearch(0)">
			<el-option v-for="item in selectOptions" :key="item.key" :label="item.name" :value="item.key"> </el-option>
		</el-select>
        <div class="line"></div>
        <i class="el-icon-search search-icon"></i>
        <el-input @change="onSearch(0)" clearable class="input-content mr-12" placeholder="请输入关键字进行搜索" v-model="search.value"></el-input>
        <div class="search-btn fz-14" @click="onSearch(1)">搜索</div>
	</div>
</template>
<script>

export default {
	data() {
		return {
            selectOptions: newDataMap.SHOP_MANAGE.SEARCH_OPTIONS,
            search:{
                selectType:'outerProductName', //下拉框的 value
                value: '', // 输入框 value
            }
        };
	},
    methods:{
        onSearch(type){
            this.$emit('change',this.search,type)
        },
        onClear(){
            this.search.value = '';
            this.$emit('change',this.search,1)
        }
    }
};
</script>
<style lang="less" scoped>
.search-input {
    display: flex;
    align-items: center;
	margin: 0 auto;
	box-sizing: border-box;
	width: 634px;
	height: 40px;
	border-radius: 8px;
	border: 2px solid @color-primary;
    .select-content{
       max-width: 100px;
    }
    .line{
        margin-right: 13px;
        width: 1px;
        height: 12px;
        background: @color-gy3;
    }
    .search-icon{
        font-size: 13px;
        color: @color-gy9
    }
    .search-btn{
        position: relative;
        left: 1px;
        width: 68px;
        height: 40px;
        border-radius: 8px;
        background:  @color-primary;
        font-family: 'PingFangSC-Medium';
        color:@color-white;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
    }
    .input-content{
        width: 430px;
    }
    /deep/ .select-content .el-input__inner{
        border: none;
    }
    /deep/ .input-content .el-input__inner{
        border: none;
    }
}
</style>
